<template>
  <component
    :is="selectedComponent"
    :show-icon="showIcon"
    :price="price"
    class="provider"
  />
</template>

<script>
import { mapGetters } from "vuex";
import { paymentMethods } from "@/config.js";
import Clearpay from "@/components/product-display/bnpl-providers/ClearpayV2.vue";
import Klarna from "@/components/product-display/bnpl-providers/KlarnaV2.vue";

export default {
  name: "BNPLInformation",
  components: {
    Clearpay,
    Klarna,
  },
  props: {
    showIcon: {
      type: Boolean,
      default: true,
    },
  },
  computed: {
    ...mapGetters("app", ["currencyCode"]),
    ...mapGetters("product", ["price"]),
    selectedComponent() {
      const klarnaEnabled = paymentMethods[this.currencyCode]?.klarnaEnabled;
      const clearpayEnabled =
        paymentMethods[this.currencyCode]?.clearpayEnabled;

      if (clearpayEnabled && klarnaEnabled) {
        // If both Clearpay and Klarna are enabled, show Clearpay
        return "Clearpay";
      } else if (clearpayEnabled) {
        // If only Clearpay is enabled, show Clearpay
        return "Clearpay";
      } else if (klarnaEnabled) {
        // If only Klarna is enabled, show Klarna
        return "Klarna";
      } else {
        // If neither are enabled, return null or an empty string, or choose a default component
        return null;
      }
    },
  },
};
</script>

<style lang="scss" scoped>
.provider {
  display: flex;
  align-items: center;
  justify-content: center;
  @include t__utility-body-10;

  img {
    margin-left: 6px;
  }
}
</style>
